import Vue from "vue";
import Money from "v-money";

export default Vue.use(Money);
